'use client';

import { create } from 'zustand';

export const ITINERARY_ITEM_ID_PREFIX = 'itinerary-item-';

type OverviewProgressState = {
  progress: number | null;
  setProgress: (value: number | null) => void;
  overlayOpen: boolean;
  setOverlayOpen: (open: boolean) => void;
  activeItemId: string | null;
  setActiveItemId: (value: string | null) => void;
};

export const useOverviewProgressStore = create<OverviewProgressState>((set) => ({
  progress: null,
  setProgress: (value) => set({ progress: value }),
  overlayOpen: false,
  setOverlayOpen: (open) => set({ overlayOpen: open }),
  activeItemId: null,
  setActiveItemId: (value) => set({ activeItemId: value })
}));
